import { render, staticRenderFns } from "./TabletViewer.vue?vue&type=template&id=57ba1342&scoped=true"
import script from "./TabletViewer.vue?vue&type=script&lang=js"
export * from "./TabletViewer.vue?vue&type=script&lang=js"
import style0 from "./TabletViewer.vue?vue&type=style&index=0&id=57ba1342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba1342",
  null
  
)

export default component.exports